import PropTypes from 'prop-types';
import { NavLink as RouterLink, useLocation } from 'react-router-dom';
import { Box, List, ListItemText } from '@mui/material';
import { StyledNavItem, StyledNavItemIcon } from './styles';
import { getAcl, removeUserSession, fetchLog } from 'src/utils/common';

NavSection.propTypes = {
  data: PropTypes.array,
};

export default function NavSection({ data = [], ...other }) {
  const navconficMain = [];
  const navconficManage = [];
  const navconficLogout = [];

  data.map((c, i) => {
    const acl = JSON.parse(getAcl());
    const menu = acl?.find((e) => c.namaroute === e.nama_menu && e.read === true);

    if (c.title === 'Dashboard' || c.title === 'Dataset Map' || c.title === 'Alerts') {
      navconficMain.push(c);
    }
    if (
      c.title === 'Calendar' ||
      c.title === 'Information' ||
      c.title === 'Reports' ||
      c.title === 'Actions' ||
      c.title === 'Users' ||
      c.title === 'About' ||
      c.title === 'Activity Log'
    ) {
      navconficManage.push(c);
    }
    if (c.title === 'Logout') {
      navconficLogout.push(c);
    }
    // if (menu !== undefined || c.namaroute === 'logout') {
    //   navconficMain.push(c);
    // }
    // navconficMain.push(c);

    return c;
  });
  return (
    <Box {...other}>
      <List disablePadding sx={{ p: 1 }}>
        <div style={{ marginLeft: 20, color: '#12A2CE', fontWeight: 'bold' }}>Main</div>
        {navconficMain?.map((item) => (
          <NavItem key={item.title} item={item} />
        ))}
        {navconficManage?.length == 0 ? (
          ''
        ) : (
          <div style={{ marginLeft: 20, color: '#12A2CE', fontWeight: 'bold' }}>Manage</div>
        )}
        {navconficManage?.map((item) => (
          <NavItem key={item.title} item={item} />
        ))}
        <hr
          style={{ aligtenContent: 'center', marginLeft: 20, marginRight: 20 }}
          className="mt-6 border-b-1 border-blueGray-300"
        />

        {navconficLogout?.map((item) => (
          <NavItem key={item.title} item={item} />
        ))}
      </List>
    </Box>
  );
}

// ----------------------------------------------------------------------

NavItem.propTypes = {
  item: PropTypes.object,
};

function NavItem({ item }) {
  const { title, path, icon, info } = item;
  return (
    <StyledNavItem
      component={RouterLink}
      to={path}
      onClick={(event) => {
        if (title === 'Logout') {
          // fetchLog(window.REACT_APP_API_PURE + 'user/logout');
          setTimeout(() => {
            removeUserSession();
          }, 2000);
        }
      }}
      sx={{
        '&.active': {
          color: 'white',
          bgcolor: '#12A2CE',
          fontWeight: 'fontWeightBold',
        },
        color: '#12A2CE',
      }}
    >
      <StyledNavItemIcon>{icon && icon}</StyledNavItemIcon>
      <ListItemText disableTypography primary={title} />
      {info && info}
    </StyledNavItem>
  );
}
